import { defaults, isNull } from 'lodash-es';
import { MAX_CODE_LENGTH } from '../../constants';
import extractCodeFromNumber from '../extractCodeFromNumber';
import getCodeByISOCode from '../getCodeByISOCode';
import getISOCodeByCode from '../getISOCodeByCode';
import { CreateValueFunction, CreateValueProps } from '../types';

const createValue =
  ({ valueProp, codesListItems }: CreateValueProps): CreateValueFunction =>
  (number, isoCode) => {
    const data: Partial<{ number: string; isoCode: string }> = {};

    if (!isNull(number)) {
      data.number = number;

      const shouldCheckForCode = number.length <= MAX_CODE_LENGTH;

      if (shouldCheckForCode) {
        const extractedCode = extractCodeFromNumber(codesListItems, number);

        data.isoCode = extractedCode
          ? getISOCodeByCode(codesListItems, extractedCode)
          : undefined;
      }
    } else if (!isNull(isoCode)) {
      const foundCode =
        getCodeByISOCode(codesListItems, isoCode as string) ?? '';

      Object.assign(data, {
        isoCode,
        number: foundCode
      });
    }

    return defaults(data, valueProp) as {
      number: string;
      isoCode: string | undefined;
    };
  };

export default createValue;
